import React from 'react';
import { TableLoader, TableHeader } from '../../commons';
import { UserGrouptype } from '../../../redux/userManagement/userManagementTypes';
import { TableHeadersType } from '../../../constant/tableHeadersConstants/tableHeadersType';
import UserGroupTableData from './UserGroupTableData';

type AppProps = {
  userGroupsList: [] | UserGrouptype[];
  tableHeaders: TableHeadersType[];
  fetching: boolean;
  isEditUserGroupsPresent: boolean;
  handleRedirectToEditUserGroup: (menuGroupId: number | undefined) => void;
}

const UserGroupTable = ({
  userGroupsList,
  tableHeaders,
  handleRedirectToEditUserGroup,
  fetching,
  isEditUserGroupsPresent
}: AppProps) => {

  return (
    <>
      {
        fetching ? <TableLoader
          Rows={10}
          ColumnPerRow={5}
        /> :
          <div className="row">
            <div className="col-md-12">
              <div className="table-bordered">
                <table className="table table-striped">
                  <thead className='text-center'>
                    <TableHeader
                      tableHeader={tableHeaders}
                      extraHeader
                    />
                  </thead>
                  <tbody>
                    <UserGroupTableData
                      tableHeaders={tableHeaders}
                      data={userGroupsList}
                      handleRedirectToEditUserGroup={handleRedirectToEditUserGroup}
                      isEditUserGroupsPresent={isEditUserGroupsPresent}
                    />
                  </tbody>
                </table>
              </div>
            </div>
          </div>
      }
    </>
  )
};

export default UserGroupTable;